import _createForOfIteratorHelper from "/builds/hooxitech/polgozar-front-end/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import React from 'react';
var eventToPropRecord = {
  'click': 'onClick'
};
export function withStopPropagation(events, element) {
  var props = Object.assign({}, element.props);
  var _iterator = _createForOfIteratorHelper(events),
    _step;
  try {
    var _loop = function _loop() {
      var key = _step.value;
      var prop = eventToPropRecord[key];
      props[prop] = function (e) {
        var _a, _b;
        e.stopPropagation();
        (_b = (_a = element.props)[prop]) === null || _b === void 0 ? void 0 : _b.call(_a, e);
      };
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return React.cloneElement(element, props);
}